import { useDispatch, useSelector } from "react-redux"
import { State } from "../../../reducers"

import SubirComprobanteIcon from '../../../media/felsv/dark_file_plus.svg'
import VerComprobanteIcon from '../../../media/felsv/Open_Eye.svg'
import ImprimirReciboIcon from '../../../media/felsv/Printer.svg'
import ImprimirFacturaIcon from '../../../media/felsv/dark_bill_icon.svg'

import Tooltip from "../../../components/Inputs/Tooltip"
import ModalComprobante from "./ModalComprobante"
import {bindActionCreators} from 'redux'
import { useEffect, useState } from "react"
import { ModalRecibo } from "./ModalRecibo"
import { generalOpenModalError, generalOpenModalInfo, generalShowLoader } from "../../../actions/general.actions"
import { apiGetReciboCliente } from "../../../actions/suscripcion/suscripcion.actions"
import ModalImprimirFactura from "../../../components/Modals/ModalsFacturacion/ModalImprimirFactura"
import ModalComprobanteGeneral from "./ModalComprobanteGeneral"
import { actionsSuscripcion } from "../../../actions/action-creators"
import { formatDateTime } from "../../../utils/strings.utils"

export default function CardComprobantes () {
    const dispatch = useDispatch();
    const {datos} = useSelector((state: State) => state.userLogin)
    const datosSuscripcion = useSelector((state: State) => state.suscripcion.datosSuscripcion)
    const {seleccion, validarSaldo} = useSelector((state: State) => state.suscripcion)
    const {planFacturas, serviciosAdicionales} = useSelector((state: State) => state.catalogos)

    const [modalSubirComprobante, setModalSubirComprobante] = useState(false)
    const [modalRecibo, setModalRecibo] = useState(false);
    const [modalFactura, setModalFactura] = useState(false);
    const [modalSubirComprobanteGeneral, setModalSubirComprobanteGeneral] = useState(false)

    const [dataModal, setDataModal] = useState<any>(null);
    const [visualizar, setVisualizar] = useState(false);

    const actions = bindActionCreators(actionsSuscripcion, dispatch)

    useEffect(() => {
        window.scroll(0, 0)
        actions.suscripcionGetDatosSuscripcion()
        actions.GetValidarSaldo()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const total = () => {
        let total = 0
        seleccion?.EmpresaServicios?.forEach((servicio: any) => {
            total += parseFloat(servicio?.montofacturar || '0')*servicio?.cantidadfacturar
        })
        return total
    }

    const handleOpenRecibo = async (datosPago: any) => {
        if (!datosPago?.idrecibo) {
            dispatch(generalOpenModalInfo('El pago no cuenta con recibo'));
            return;
        }

        try {
            dispatch(generalShowLoader(true))
            const response: any = await apiGetReciboCliente({username: datos?.username?.toLowerCase(), idrecibo: datosPago?.idrecibo});
            if(response?.data){
                const reciboData = response.data;
                setDataModal({...reciboData, detalle_impresion: reciboData});
                setModalRecibo(true); 
            }
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error a cargar los datos del recibo'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const handleOpenFactura = async (datosPago: any) => {
        if (!datosPago?.idserviciodte) {
            dispatch(generalOpenModalInfo('El pago no cuenta con factura'));
            return;
        }   

        setDataModal({idserviciodte: datosPago?.idserviciodte});
        setModalFactura(true); 
    }
    
    return (
        <div className='card w-10'>
            {modalSubirComprobante && <ModalComprobante visualizar = {visualizar} data={dataModal} onClose = {() => setModalSubirComprobante(false)}/>}
            {modalSubirComprobanteGeneral && <ModalComprobanteGeneral data={dataModal} onClose = {() => 
                    {
                        actions.suscripcionGetDatosSuscripcion();
                        actions.GetValidarSaldo();
                        setModalSubirComprobanteGeneral(false);
                    }
                }
            />}
            {modalRecibo && <ModalRecibo datosRecibo={dataModal} onResult = {() => setModalRecibo(false)}/>}
            {modalFactura && <ModalImprimirFactura customBody={dataModal} metodoGet="getImpresionFacturaById" onCancel = {() => setModalFactura(false)} onPrint = {() => setModalFactura(false)}/>}
            
            <div style={{display: 'flex', background: '#13ad90', padding: '30px', borderRadius: '10px', color: '#FFFFFF', flexDirection: 'column'}}>
                <h4 className='h4-titles' style={{color: '#FFFFFF'}}>{planFacturas.find((plan: any) => `${plan?.idtiposuscripcion}` === `${seleccion?.idsuscripcion}`)?.nombresuscripcion}</h4>
                <table>
                    <tbody>
                        <tr>
                            <td colSpan={4}> {planFacturas.find((plan: any) => `${plan?.idtiposuscripcion}` === `${seleccion?.idsuscripcion}`)?.descripcion}</td>
                        </tr>
                        <tr>
                            <td colSpan={4}>
                                <hr className="separador" style={{background: '#FFFFFF'}}/> 
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <h4 className='h4-titles' style={{color: '#FFFFFF'}}>Cargos</h4>
                            </td>
                            <td style={{fontWeight: '700', textAlign: 'center'}}>Cantidad</td>
                            <td style={{fontWeight: '700', textAlign: 'right'}}>Precio unitario</td>
                            <td style={{fontWeight: '700', textAlign: 'right'}}>Total</td>
                        </tr>
                        {seleccion?.EmpresaServicios?.map((servicio: any) => (
                            <tr>
                                <td>{serviciosAdicionales?.find((adicional: any) => adicional?.idservicioadicional === servicio?.idservicioadicional)?.nombreservicio}</td>
                                <td style={{textAlign: 'center'}}>{servicio?.cantidadfacturar}</td>
                                <td style={{textAlign: 'right'}}>{(parseFloat(servicio?.montofacturar || '0'))?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                <td style={{textAlign: 'right'}}>{(parseFloat(servicio?.montofacturar || '0')*servicio?.cantidadfacturar)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={4}><hr className="separador" style={{background: '#FFFFFF'}}/></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>Total</td>
                            <td style={{textAlign: 'right'}}>{total()?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='separador'/>
            <div style={{ display: 'flex', justifyContent: 'end', margin: '16px 0px' }}>
                <Tooltip text={'Abonar saldo'}>
                    <button
                        onClick={() => {setModalSubirComprobanteGeneral(true); setDataModal(null); setVisualizar(false);}}
                        style={{display: 'flex', width: 'auto', borderRadius: '100px'}} 
                        className="button m">
                        Subir comprobante
                    </button>
                </Tooltip>
            </div>
            <h4 className='h4-titles' style={{marginTop: '10px'}}>Detalle de pagos</h4>
            <div className='separador'/>
            <div className="tab-plane" style={{overflow: 'auto'}}>
                {
                    datosSuscripcion?.historial_pagos?.find((p: any) => p?.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoPagos.length > 0 &&
                                
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Acciones</td>
                                <td>Factura</td>
                                <td>Monto</td>
                                <td>Mora</td>
                                <td>Fecha</td>
                                <td>Estado del pago</td>
                                <td>Estado del comprobante</td>
                                <td>Observaciones del comprobante</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                datosSuscripcion?.historial_pagos?.find((p: any) => p?.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoPagos.map((pago: any) => {

                                    return(
                                    <tr>
                                        <td data-label = 'Acciones' style={{display: 'flex', flexWrap: 'wrap'}}>
                                            {
                                            (
                                            datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.idestadocomprobante !== 6 &&
                                            datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.idestadocomprobante !== 3 &&
                                            datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.idestadocomprobante !== 2
                                            ) &&
                                            <Tooltip text="Subir comprobante">
                                                <button onClick={() => {setModalSubirComprobante(true); setDataModal(pago); setVisualizar(false)}} className="table-action">
                                                    <img style={{height: '15px', width: '15px'}} src={SubirComprobanteIcon} className="table-img-action" alt="Upload"/>
                                                </button>
                                            </Tooltip>
                                            }
                                            {
                                            (
                                            datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.idestadocomprobante !== 6 &&
                                            datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.idestadocomprobante !== 1
                                            ) && 
                                            <Tooltip text="Ver comprobante">
                                                <button onClick={() => {setModalSubirComprobante(true); setDataModal({...pago, iddetallecomprobante: datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.iddetallecomprobante}); setVisualizar(true)}} className="table-action">
                                                    <img style={{height: '15px', width: '15px'}} src={VerComprobanteIcon} className="table-img-action" alt="Upload"/>
                                                </button>
                                            </Tooltip>
                                            }
                                            <Tooltip text="Imprimir recibo">
                                                <button onClick={() => {handleOpenRecibo({...pago})}} className="table-action">
                                                    <img style={{height: '15px', width: '15px'}} src={ImprimirReciboIcon} className="table-img-action" alt="Upload"/>
                                                </button>
                                            </Tooltip>
                                            {
                                                pago?.idserviciodte && 
                                                (
                                                    <Tooltip text="Ver factura">
                                                        <button onClick={() => {handleOpenFactura({...pago})}} className="table-action">
                                                            <img style={{height: '15px', width: '15px'}} src={ImprimirFacturaIcon} className="table-img-action" alt="Upload"/>
                                                        </button>
                                                    </Tooltip>
                                                )
                                            }
                                        </td>
                                        <td data-label = 'Factura'>{pago?.numerofactura ?? 'N/A'}</td>
                                        <td data-label = 'Monto'>{parseFloat(pago?.montopago)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label = 'Mora'>{parseFloat(pago?.montomora)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                        <td data-label = 'Fecha'>{pago?.fnprocesamiento ?? '--'}</td>
                                        <td data-label = 'Estado pago' >
                                            <div className="btn-estado-suscripcion" style={{textAlign: 'center' ,...estadoGetStyle(pago?.EstadoPago?.color)}}>
                                                {pago?.EstadoPago?.nombre}
                                            </div>
                                        </td>
                                        <td data-label = 'Estado comprobante'>
                                            <div className="btn-estado-suscripcion" style={{textAlign: 'center',...estadoGetStyle(datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.color)}}>
                                                {datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.EstadoComprobante?.nombre}
                                            </div>
                                        </td>
                                        <td data-label = 'Observaciones'>{datosSuscripcion?.historial_pagos?.find((h: any) => h.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoComprobantes?.find((c: any) => c?.iddetalleestadopago === pago?.iddetalleestadopago)?.observaciones || '--'}</td>
                                    </tr>
                                )
                            
                            })
                            }
                        </tbody>
                    </table>
                }
                {
                    datosSuscripcion?.historial_pagos?.find((p: any) => p?.idempresadetallepago === seleccion?.EmpresaDetallePagos[0]?.idempresadetallepago)?.DetalleEstadoPagos.length === 0 &&
                        <p style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>No hay datos a mostrar</p>
                }
            </div>
        </div>
    )
}

const estadoGetStyle = (color: string) => {
    return {background: color, color: 'white', borderRadius: '100px', padding: '10px', maxWidth: '200px'}
}
